import React from 'react';

export const ShareLinkSvg = (): React.ReactElement => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.3856 13.0208C12.3383 14.9734 15.5041 14.9734 17.4567 13.0208L18.8709 11.6066C20.8235 9.65399 20.8235 6.48816 18.8709 4.53554C16.9183 2.58292 13.7525 2.58292 11.7998 4.53554L10.3856 5.94976"
        stroke="#697684"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.0208 10.3856C11.0682 8.43302 7.90237 8.43302 5.94975 10.3856L4.53553 11.7999C2.58291 13.7525 2.58291 16.9183 4.53553 18.8709C6.48816 20.8235 9.65398 20.8235 11.6066 18.8709L13.0208 17.4567"
        stroke="#697684"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const LineSvg = (): React.ReactElement => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22 11.1282C22 6.63937 17.5195 3 12 3C6.4733 3 2 6.63937 2 11.1282C2 15.1263 5.557 18.4508 10.2395 19.1318C10.2936 19.1392 10.3495 19.1465 10.4053 19.1538C10.4613 19.1611 10.5173 19.1684 10.5714 19.1758C11.5676 19.3862 11.4036 20.254 11.2668 20.9774C11.1847 21.4119 11.1124 21.7944 11.3074 21.9511C11.9062 22.427 16.4589 19.3369 19.2222 16.7447C19.6263 16.4078 19.987 16.0417 20.3117 15.6463L20.3189 15.6389C20.3983 15.5511 20.4632 15.4778 20.5065 15.4046C21.4517 14.1597 22 12.6952 22 11.1282ZM6.2372 13.7204H6.20112C5.91252 13.7204 5.68164 13.4787 5.68164 13.1858V9.26089C5.68164 8.97531 5.91252 8.73366 6.20112 8.73366H6.24441C6.5258 8.73366 6.76389 8.96798 6.76389 9.26089V12.622H8.21411C8.49549 12.622 8.73359 12.8563 8.73359 13.1492V13.1932C8.73359 13.4787 8.50271 13.7204 8.21411 13.7204H6.24441H6.2372ZM18.6975 11.216V11.26C18.6975 11.5529 18.4594 11.7872 18.1708 11.7872H16.7206V12.6293H18.1708C18.4522 12.6293 18.6903 12.8636 18.6903 13.1565V13.2005C18.6903 13.4861 18.4594 13.7277 18.1708 13.7277H16.2011H16.1939H16.1578C15.8764 13.7277 15.6383 13.4934 15.6383 13.2005V9.27554C15.6383 8.98995 15.8692 8.7483 16.1578 8.7483H16.1939H16.2011H18.1708C18.4522 8.7483 18.6903 8.98263 18.6903 9.27554V9.31947C18.6903 9.60506 18.4594 9.8467 18.1708 9.8467H16.7206V10.6888H18.178C18.4594 10.6888 18.6975 10.9231 18.6975 11.216ZM14.9674 13.1858C14.9674 13.3323 14.9096 13.4641 14.8158 13.5593C14.787 13.5959 14.7437 13.6325 14.686 13.6472C14.6138 13.6838 14.5272 13.7057 14.4407 13.7057H14.3974C14.3324 13.7057 14.2603 13.6911 14.2026 13.6691C14.1232 13.6398 14.051 13.5886 14.0005 13.5154C13.99 13.5046 13.9833 13.4939 13.9748 13.4803C13.9717 13.4753 13.9683 13.47 13.9645 13.4641L12.0669 10.8353V13.1858C12.0669 13.4714 11.836 13.7131 11.5474 13.7131H11.5042C11.2228 13.7131 10.9847 13.4787 10.9847 13.1858V9.26089C10.9847 8.97531 11.2156 8.73366 11.5042 8.73366H11.5474C11.7422 8.73366 11.9154 8.8435 12.002 9.0046L13.8851 11.5675V9.26089C13.8851 8.97531 14.116 8.73366 14.4046 8.73366H14.4479C14.7293 8.73366 14.9674 8.96798 14.9674 9.26089V13.1858ZM9.72204 13.7204H9.67875C9.39015 13.7204 9.15927 13.4787 9.15927 13.1858V9.26089C9.15927 8.97531 9.39015 8.73366 9.67875 8.73366H9.72204C10.0034 8.73366 10.2415 8.96798 10.2415 9.26089V13.1932C10.2415 13.4787 10.0106 13.7204 9.72204 13.7204Z"
        fill="#697684"
      />
    </svg>
  );
};

export const FacebookSvg = (): React.ReactElement => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.9345 13.165L16.4854 9.57282H13.0388V7.24167C13.0388 6.25891 13.5203 5.30097 15.064 5.30097H16.6311V2.24272C16.6311 2.24272 15.2089 2 13.8493 2C11.0106 2 9.15534 3.72039 9.15534 6.83495V9.57282H6V13.165H9.15534V21.849C9.78803 21.9483 10.4365 22 11.0971 22C11.7577 22 12.4061 21.9483 13.0388 21.849V13.165H15.9345Z"
        fill="#697684"
      />
    </svg>
  );
};

export const TwitterSvg = (): React.ReactElement => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.27501 20.2622C15.8272 20.2622 19.9566 14.0043 19.9566 8.58067C19.9566 8.40187 19.9566 8.22307 19.9481 8.05279C20.7484 7.47382 21.4466 6.75011 22 5.92422C21.2678 6.24777 20.4759 6.46914 19.6416 6.57131C20.493 6.06045 21.1401 5.26011 21.4466 4.298C20.6547 4.76628 19.7778 5.10685 18.8412 5.29417C18.092 4.49383 17.0277 4 15.8442 4C13.5794 4 11.7403 5.83908 11.7403 8.10387C11.7403 8.42742 11.7744 8.74244 11.851 9.04044C8.43678 8.87016 5.41422 7.23542 3.38782 4.74926C3.03874 5.35377 2.8344 6.06045 2.8344 6.80971C2.8344 8.23159 3.55811 9.4917 4.66496 10.2239C3.99234 10.2069 3.36228 10.0196 2.80885 9.71307C2.80885 9.7301 2.80885 9.74713 2.80885 9.76415C2.80885 11.7565 4.22222 13.4083 6.10387 13.7914C5.7633 13.8851 5.39719 13.9361 5.02256 13.9361C4.75862 13.9361 4.50319 13.9106 4.24777 13.8595C4.76714 15.4943 6.28267 16.6777 8.07918 16.7118C6.67433 17.8101 4.90336 18.4657 2.97914 18.4657C2.64708 18.4657 2.32354 18.4487 2 18.4061C3.79651 19.5811 5.95913 20.2622 8.27501 20.2622Z"
        fill="#697684"
      />
    </svg>
  );
};
